import React, {useEffect, useState} from 'react';
import {
    Box, Button, AppBar, Toolbar, TextField, Select, MenuItem, FormControl, InputLabel, Pagination, Stack, Modal
} from '@mui/material';
import {Add} from '@mui/icons-material';
import HeaderAvatar from "../components/HeaderAvatar";
import {fetchPresentation, fetchProject, fetchVisit, getNewProjStatistics, getNewStatistics} from "../services/api";
import {AllProjStat, AllStat, FullProjStat, FullStat, Presentation, Slide} from "../services/types";
import {all} from "axios";
import {data} from "react-router-dom";
import {toInteger} from "lodash";

function formatDate(isoString: string) {
    const date = new Date(isoString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;
}


const Statistics: React.FC = () => {
    // --- State для фильтров ---
    const [dateFrom, setDateFrom] = useState<string>('');
    const [dateTo, setDateTo] = useState<string>('');
    const [doctorId, setDoctorId] = useState<string>('');
    const [project, setproject] = useState<string>('');
    const [slide, setslide] = useState<string>('');
    const [currentProjectVisitSlides, setCurrentProjectVisitSlides] = useState<Slide[] | null>(null);
    const [statBySlideOpen, setStatBySlideOpen] = useState<boolean>(false);

    // --- State для пагинации ---
    const [page, setPage] = useState<number>(1);
    const [pageSize] = useState<number>(20); // фиксированный размер страницы
    const [totalPages, setTotalPages] = useState<number>(1);

    const [loading, setLoading] = useState(true);
    const [statFull, setStatFull] = useState<FullStat[]>([]);
    const [fullProjStat, setFullProjStat] = useState<FullProjStat[]>([]);
    const [allStat, setAllStat] = useState<AllStat[]>([]);
    const [allProjStat, setAllProjStat] = useState<AllProjStat>();
    const [presId, setPresId] = useState<string>("");
    const [currentDoctor, setCurrentDoctor] = useState<string>("");
    const [statSlides, setStatSlides] = useState<FullStat[]>([]);

    useEffect(() => {
        loadAllStat();
    }, [dateFrom, dateTo, doctorId, project, slide, page]);

    // useEffect(() => {
    //     if (presId) {
    //         fetchPresentation(presId).then(setCurrentPresentation);
    //     }else{
    //         setCurrentPresentation(null)
    //     }
    // }, [presId]);

    const loadAllStat = async () => {
        setLoading(true);
        try {
            const data = await getNewProjStatistics(
                dateFrom || null,
                dateTo || null,
                doctorId || null,
                project || null,
                page,
                pageSize
            );
            setFullProjStat(data.items);
            setAllProjStat(data);
            setTotalPages(Math.ceil(data.total/pageSize) || 1); // предполагается есть поле total_pages
            setLoading(false);
        } catch (error) {
            console.error('Error fetching statistics:', error);
            setLoading(false);
        }
    };

    // --- Обработчики ---
    const handlePageChange = (_: React.ChangeEvent<unknown>, value: number) => setPage(value);

    const loadProjectStat = async (id: number, doctor_id: string) => {
        // setLoading(true)
        try {
            setCurrentDoctor(doctor_id)
            var presData = await fetchProject(id)
            var visitData = await fetchVisit(presData.visitId)
            setCurrentProjectVisitSlides(visitData.slides)

            setStatBySlideOpen(true)

            const data = await getNewStatistics(
                null,
                null,
                null,
                doctor_id || null,
                id+"" || null,
                null,
                page,
                100
            )

            var projSlides: any[] = []
            visitData.slides.forEach((item: Slide) => {
                var total_viewed = 0
                var session_count = 0
                var last_created_at = ""

                data.items.forEach((itemIn: FullStat) => {
                    if (itemIn.slide == item.title){
                        total_viewed = itemIn.total_viewed
                        session_count = itemIn.session_count
                        last_created_at = itemIn.last_created_at
                    }
                });

                projSlides.push({
                    id: item.id,
                    slide: item.title,
                    slide_duration: Math.ceil(item.durationMs/1000),
                    total_viewed: total_viewed,
                    session_count: session_count,
                    last_created_at: last_created_at
                })
            });

            setStatFull(projSlides)


            console.log(projSlides)
            // setPresId(id)
            // // const data = await getStatisticsByVisit();
            // // setStatByVisit(data.items);
            // // setTotalPages(data.total_pages);
            // // setTotalElements(data.total);
            // setLoading(false)
        } catch (error) {
            console.error('Error fetching team members:', error);
            setLoading(false)
        }
    };


    return (
        <Box>
            <AppBar className={loading ? 'headerBlock preloading' : 'headerBlock'} position="static">
                <Toolbar className='toolbar'>
                    <Box className='toolbarTitle'>Статистика</Box>
                    <Button className="addToobarBtn" variant="contained" onClick={() => {}}><Add /></Button>
                    <HeaderAvatar/>
                </Toolbar>
            </AppBar>
            {/* Фильтры */}
            <Box sx={{ p: 3, mt: 2, mb: 3, display: 'flex', gap: 2, alignItems: 'center' }}>
                <TextField
                    type='date'
                    size="small"
                    label="С даты"
                    InputLabelProps={{ shrink: true }}
                    value={dateFrom}
                    onChange={e => setDateFrom(e.target.value)}
                />
                <TextField
                    type='date'
                    size="small"
                    label="По дату"
                    InputLabelProps={{ shrink: true }}
                    value={dateTo}
                    onChange={e => setDateTo(e.target.value)}
                />
                <TextField
                    size="small"
                    label="Доктор"
                    value={doctorId}
                    onChange={e => setDoctorId(e.target.value)}
                />
                <TextField
                    size="small"
                    label="Проект"
                    value={project}
                    onChange={e => setproject(e.target.value)}
                />
                {/*<Button variant="outlined" onClick={() => setPage(1)}>Применить</Button>*/}
            </Box>

            {!loading && (
                <>
                    <Box className='statListHeader'>
                        <Box className="statListHeaderItem">ID врача</Box>
                        <Box className="statListHeaderItem">Проект</Box>
                        <Box className="statListHeaderItem">Длит.<br/> видео (сек.)</Box>
                        <Box className="statListHeaderItem">Общее время<br/> просмотра (сек.)</Box>
                        <Box className="statListHeaderItem">Количество<br/> сессий</Box>
                        <Box className="statListHeaderItem">Посл.<br/>оценка</Box>
                        <Box className="statListHeaderItem">Средн.<br/>оценка</Box>
                        <Box className="statListHeaderItem">Процент<br/> просмотра</Box>
                        <Box className="statListHeaderItem">Дата посл.<br/> визита</Box>
                    </Box>

                    <Box className='statList'>
                        {fullProjStat.map((item, index) => (
                            <Box className='statListItem' key={index} onClick={() => loadProjectStat(toInteger(item.project_id), item.doctor_id)}>
                                <Box sx={{ flexGrow: 1 }} className='statListText'>{item.doctor_id}</Box>
                                <Box sx={{ flexGrow: 1 }} className='statListText'>{item.project}</Box>
                                <Box sx={{ flexGrow: 1 }} className='statListText'>{item.pres_duration}</Box>
                                <Box sx={{ flexGrow: 1 }} className='statListText'>{item.project_total_duration}</Box>
                                <Box sx={{ flexGrow: 1 }} className='statListText'>{item.session_count}</Box>
                                <Box sx={{ flexGrow: 1 }} className='statListText'>{item.last_rating}</Box>
                                <Box sx={{ flexGrow: 1 }} className='statListText'>{item.avg_rating?.toFixed(2)}</Box>
                                <Box sx={{ flexGrow: 1 }} className='statListText'>{item.percent_viewed}%</Box>
                                <Box sx={{ flexGrow: 1 }} className='statListText'>{item.last_created_at}</Box>
                            </Box>
                        ))}
                    </Box>


                    {/* Пагинация */}
                    {totalPages > 1 ?
                    <Stack spacing={2} sx={{mt: 2, mb: 2, alignItems: 'center'}}>
                        <Pagination
                            count={totalPages}
                            page={page}
                            color="primary"
                            onChange={handlePageChange}
                        />
                    </Stack>
                        :null}
                </>


            )}

            <Modal open={statBySlideOpen} onClose={() => setStatBySlideOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, width: '90%', padding: 0 }}>
                        <Box className='statListHeader'>
                            <Box className="statListHeaderItem">ID врача</Box>
                            <Box className="statListHeaderItem">Слайд</Box>
                            <Box className="statListHeaderItem">Длит.<br/> слайда (сек.)</Box>
                            <Box className="statListHeaderItem">Общее время<br/> просмотра (сек.)</Box>
                            <Box className="statListHeaderItem">Процент<br/> просмотра</Box>
                            <Box className="statListHeaderItem">Время просмотра</Box>
                        </Box>
                        <Box className='statList'>
                            {/*{currentProjectVisitSlides?.map((item) => (*/}
                            {/*    <Box className='statListSlideItem' key={item.id}>*/}
                            {/*        <Box sx={{ flexGrow: 1 }} className='statListText'>{currentDoctor}</Box>*/}
                            {/*        <Box sx={{ flexGrow: 1 }} className='statListText'>{item.title}</Box>*/}
                            {/*        <Box sx={{ flexGrow: 1 }} className='statListText'>{Math.ceil(item.durationMs/1000)}</Box>*/}
                            {/*        <Box sx={{ flexGrow: 1 }} className='statListText'></Box>*/}
                            {/*        <Box sx={{ flexGrow: 1 }} className='statListText'></Box>*/}
                            {/*        <Box sx={{ flexGrow: 1 }} className='statListText'></Box>*/}
                            {/*    </Box>*/}
                            {/*))}*/}
                            {statFull.map((item) => (
                                <Box className='statListSlideItem' key={item.slide}>
                                    <Box sx={{ flexGrow: 1 }} className='statListText'>{currentDoctor}</Box>
                                    <Box sx={{ flexGrow: 1 }} className='statListText'>{item.slide}</Box>
                                    <Box sx={{ flexGrow: 1 }} className='statListText'>{Math.ceil(item.slide_duration)}</Box>
                                    <Box sx={{ flexGrow: 1 }} className='statListText'>{Math.ceil(item.total_viewed)}</Box>
                                    <Box sx={{ flexGrow: 1 }} className='statListText'>{
                                        Math.ceil(item.total_viewed * 100 / item.slide_duration) > 100 ? "100" : Math.ceil(item.total_viewed * 100 / item.slide_duration)
                                    }%</Box>
                                    <Box sx={{ flexGrow: 1 }} className='statListText'>{item.last_created_at!='' ? formatDate(item.last_created_at) : ''}</Box>
                                </Box>
                            ))}
                        </Box>
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2, padding: 2}}>
                            <Box></Box>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setStatBySlideOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Закрыть
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

        </Box>
    );
};

export default Statistics;
